import { render, staticRenderFns } from "./UserDetailFinancesTile.vue?vue&type=template&id=05fa877e&scoped=true&lang=pug&"
import script from "./UserDetailFinancesTile.vue?vue&type=script&lang=js&"
export * from "./UserDetailFinancesTile.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailFinancesTile.vue?vue&type=style&index=0&id=05fa877e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fa877e",
  null
  
)

export default component.exports